import { render, staticRenderFns } from "./modalMateriales.vue?vue&type=template&id=b96c6e86&scoped=true&"
import script from "./modalMateriales.vue?vue&type=script&lang=js&"
export * from "./modalMateriales.vue?vue&type=script&lang=js&"
import style0 from "./modalMateriales.vue?vue&type=style&index=0&id=b96c6e86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96c6e86",
  null
  
)

export default component.exports